import { StatCard } from "../../pages/dashboards/v5/components/V5Charts";
import { getThemeClasses } from "../../utils/ThemeClasses";
import { useReportingSummary } from "../../features/dashboards/reporting";
import type { ReportingPlatform } from "../../features/dashboards/reportingConfig";

export default function PlatformStatsCards({
  platform,
  themeClasses,
}: {
  platform: ReportingPlatform;
  themeClasses: ReturnType<typeof getThemeClasses>;
}) {
  const summaryQuery = useReportingSummary();
  const s = summaryQuery.data?.by_platform?.[platform];
  const loading = summaryQuery.isLoading;

  return (
    <div className="space-y-2">
      <div className="flex justify-end">
        <span
          title="Dato en vivo de reporting/summary (últimas 24 h)."
          className={`text-[11px] whitespace-nowrap inline-flex items-center gap-1 px-2.5 py-1 rounded-full border ${themeClasses.cardBorder} ${themeClasses.textSecondary}`}
        >
          <i className="ri-broadcast-line" />
          En vivo · últimas 24 h
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 sm:gap-4">
      <StatCard
        icon={<i className="ri-truck-line text-white text-sm"></i>}
        label="Unidades"
        value={loading ? "..." : (s?.total ?? 0)}
        sublabel="Total"
        iconBgColor="bg-blue-500"
        themeClasses={themeClasses}
      />
      <StatCard
        icon={<i className="ri-check-line text-white text-sm"></i>}
        label="Reportando"
        value={loading ? "..." : (s?.reporting ?? 0)}
        sublabel="Últimas 24h"
        iconBgColor="bg-green-500"
        themeClasses={themeClasses}
      />
      <StatCard
        icon={<i className="ri-close-line text-white text-sm"></i>}
        label="No reportando"
        value={loading ? "..." : (s?.not_reporting ?? 0)}
        sublabel="Últimas 24h"
        iconBgColor="bg-red-500"
        themeClasses={themeClasses}
      />
      <StatCard
        icon={<i className="ri-user-line text-white text-sm"></i>}
        label="Usuarios"
        value={loading ? "..." : (s?.users ?? 0)}
        sublabel="Total"
        iconBgColor="bg-purple-500"
        themeClasses={themeClasses}
      />
      <StatCard
        icon={<i className="ri-percent-line text-white text-sm"></i>}
        label="Efectividad"
        value={loading ? "..." : `${s?.effectiveness_pct ?? 0}%`}
        sublabel="Reportando/Total"
        iconBgColor="bg-indigo-500"
        themeClasses={themeClasses}
      />
      </div>
    </div>
  );
}
